export default __webpack_public_path__ + "img/add-image.355e4c3c.svg";